import { HTMLAttributes, ReactElement } from 'react';
import { colorFillColorWithState } from 'mt-react-theme-manager';

import Icon from '../../../../components/Icon';

import './styles.scss';

interface ChangeEmailButtonProps extends HTMLAttributes<HTMLButtonElement> {
  email: string;
}

export default function ChangeEmailButton({
  email,
  className = '',
  ...rest
}: ChangeEmailButtonProps): ReactElement {
  return (
    <button
      type="button"
      className={`change-email-button ${className} ${colorFillColorWithState(`primary`)}`}
      {...rest}
    >
      <div className="email">{email}</div>
      <Icon icon="pen" />
    </button>
  );
}
